class HomeHero {
  constructor(el) {
    this.el = el;
    this.index = 0;
    this.setVars();
    this.bindEvents();
  }

  setVars() {
    this.previousButton = this.el.querySelector('[data-button-previous]');
    this.nextButton = this.el.querySelector('[data-button-next]');
    this.currentPage = this.el.querySelector('[data-current-page');

    this.items = Array.from(this.el.querySelectorAll('[data-item]'));
  }

  bindEvents() {
    this.previousButton.addEventListener('click', this.previous.bind(this));
    this.nextButton.addEventListener('click', this.next.bind(this));
  }

  previous() {
    this.update(this.index - 1);
  }

  next() {
    this.update(this.index + 1);
  }

  update(nextIndex) {
    const index = Math.max(0, Math.min(nextIndex, this.items.length - 1));

    document.startViewTransition(() => {
      this.items.forEach(function (item, i) {
        item.hidden = index !== i;
      });
    });

    this.previousButton.disabled = index === 0;
    this.nextButton.disabled = index === this.items.length - 1;
    this.currentPage.innerHTML = index + 1;

    this.index = index;
  }
}

export default HomeHero;
